import script from "./StatusNoteText.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusNoteText.vue?vue&type=script&setup=true&lang=js"

import "./StatusNoteText.vue?vue&type=style&index=0&id=07e6d397&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e6d397"]])

export default __exports__